import React, { useState, useEffect } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { Disclosure, RadioGroup, Tab } from "@headlessui/react";
import { createClient } from "@supabase/supabase-js";

// components
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import TopPropertiesCarousel from "../components/TopPropertiesCarousel/TopPropertiesCarousel";
import RoundedButton from "../components/RoundedButton/RoundedButton";
import AcreMap from "../components/AcreMap/AcreMap";
import AuthenticationModal from "../components/AuthenticationModal/AuthenticationModal";
import Modal from "../components/Modal/Modal";
import PaymentModalParent from "../components/PaymentModal/PaymentModalParent";
import AddFunds from "../components/AddFunds/AddFunds";
import EditListing from "../components/EditListing/EditListing";
// hooks
import useProperty from "../hooks/useProperty";
import { useAcreDapp } from "../providers/AcreDappProvider/AcreDappProvider";
import { useConnectWallet } from "@web3-onboard/react";
import useMostPopularProperties from "../hooks/useMostPopularProperties";
import useTrendingProperties from "../hooks/useTrendingProperties";
import useRecommendedProperties from "../hooks/useRecommendedProperties";
import useSampleProperties from "../hooks/useSampleProperties";

// utils
import { LISTING_TYPE } from "../platformUtils";

// media
import arrowLeftIcon from "../media/simple-mono-icons/arrow-left.svg";
import homeCabooseBgImg from "../media/home-caboose-bg.svg";
import verify from "../media/verify.png";
import eye from "../media/eye.png";
import heart from "../media/heart.png";
import {
  UserIcon,
  CurrencyDollarIcon,
  TrashIcon,
  IdentificationIcon,
  MapIcon,
} from "@heroicons/react/24/outline";
import { HeartIcon, EyeIcon } from "@heroicons/react/20/solid";
import { BsCardList } from "react-icons/bs";
import { FaDiscord, FaTwitter } from "react-icons/fa";
import { ChevronUpIcon } from "@heroicons/react/20/solid";
import moment from "moment";
import PurchaseButton from "../components/PurchaseButton/PurchaseButton";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function PropertyDetailPage() {
  let _ = require("lodash");
  const [{ wallet, connecting }, connect] = useConnectWallet();
  const [chosenListing, setChosenListing] = useState(null);
  const [listingImageGallery, setListingImageGallery] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showData, setShowData] = useState(false);
  const [parsedAddress, setParsedAddress] = useState(null);
  const [parsedContract, setParsedContract] = useState(null);
  const [listingLikes, setListingLikes] = useState(0);
  const [purchaseText, setPurchaseText] = useState("");
  const [purchaseModal, setPurchaseModal] = useState(<></>);
  let { listingId, privateListing } = useParams();
  const property = useProperty(listingId);
  const { walletAddress } = useAcreDapp();
  const supabase = createClient(
    `https://${process.env.REACT_APP_SUPABASE_URL}.supabase.co`,
    `${process.env.REACT_APP_SUPABASE_API_KEY}`
  );
  


  useEffect(() => {
    setChosenListing(property[0].listing);
    setListingLikes(
      property[0]?.listing?.likes ? property[0]?.listing?.likes : 0
    );
    setParsedAddress(
      _.truncate(property[0]?.listing?.contract_address, { length: 10 })
    );
    setParsedContract(
      _.truncate(property[0]?.listing?.walletAddress, { length: 10 })
    );

    property[0]?.listing?.property?.images?.platform.map((image) => {
      const { data } = supabase.storage
        .from("listings")
        .getPublicUrl(
          `images/${property[0]?.listing?.walletAddress}-${image.id}`
        );
      //console.log(data)
      setListingImageGallery((current) => {
        return [
          ...current,
          property[0]?.listing?.property?.images?.blockchain,
          data?.publicUrl,
        ];
      });
    });

    if (privateListing === "true") {
      if (!walletAddress) {
        setShowModal(true);
        setShowData(false);
      } else {
        console.log("User is logged in");
        if (
          _.toLower(walletAddress) ===
          _.toLower(property[0]?.listing?.private_wallet_address)
        ) {
          console.log("Wallet Addreses match");
          setShowModal(false);
          setShowData(true);
        } else {
          console.log("Wallet Addresses dont match", {
            walletAddress: _.toLower(walletAddress),
            private_wallet_address: _.toLower(
              property[0]?.listing?.private_wallet_address
            ),
          });
          setShowModal(true);
          setShowData(false);
        }
      }
    } else {
      console.log("listing is Public");
      setShowModal(false);
      setShowData(true);
    }

    if (property[0]?.listing?.auction?.for_auction) {
      setPurchaseText("Place Bid");
      
    } else if (property[0]?.listing?.fixed_price?.for_fixed_price) {
      setPurchaseText("Buy Now");
     
    } else if (property[0]?.listing?.rental?.for_rent) {
      setPurchaseText("Rent Now");
   
      return;
    } else {
      return;
    }
  }, [property, listingId, walletAddress, privateListing]);
  //  console.log(chosenListing);
  
  let uniq = [...new Set(listingImageGallery)];

  const handlePurchaseModal = () => {
    if (property[0]?.listing?.auction?.for_auction) {
      setPurchaseModal(
        <Modal openModal={true}  children={<PaymentModalParent purchaseType={"auction"} />} />
      );
    } else if (property[0]?.listing?.fixed_price?.for_fixed_price) {
      setPurchaseModal(
        <Modal openModal={true} children={<PaymentModalParent purchaseType={"fixed"} />} />
      );
    } else if (property[0]?.listing?.rental?.for_rent) {
      setPurchaseModal(
        <Modal openModal={true} children={<PaymentModalParent purchaseType={"rent"} />} />
      );
      return;
    } else {
      return;
    }
  };
  const handleUpdateLikes = async () => {
    setListingLikes((listingLikes) => listingLikes + 1);
    try {
      let { data, error, status } = await supabase
        .from("listings")
        .update({
          listing: { ...chosenListing, likes: listingLikes + 1 },
        })
        .eq("id", listingId);

      if (error && status !== 406) {
        throw error;
      }
      if (status) {
        console.log("[Likes]- Database status: ", status);
      }
    } catch (error) {
      console.table(error);
    }
  };

  const offers = [
    {
      id: 1,
      from: "0x1234567890",
      Price: "0.1",
      UsdPrice: "$100",
      Expiration: "1/1/2021",
    },
    {
      id: 2,
      from: "0x1234567892",
      Price: "0.2",
      UsdPrice: "$200",
      Expiration: "1/13/2021",
    },
    {
      id: 3,
      from: "0x1234567893",
      Price: "0.3",
      UsdPrice: "$300",
      Expiration: "1/23/2021",
    },
  ];

  // TODO: add a state var in URL to track what search led to this page, and return to that when clicking the "Back to search" button
  // You could use history, but we don't want it to literally act as a browser back button.
  // Ex: if you click a link to the property detail page from homepage or some other page we don't want to return there (or even to an external website)

  // TODO: get whether the user is logged in

  // TODO: get whether the user is the landlord

  return (
    <>
      <Navbar />
      <div className="relative w-full h-full">
        <main className="w-boxed mx-auto pb-32">
          <div className="flex h-10">
            <Link
              to="/explore"
              className="flex h-4 items-center text-logo-green"
            >
              <img className="mr-2" src={arrowLeftIcon} alt="" /> Back to search
            </Link>
          </div>
          <div className="grid grid-cols-12 gap-8 mb-32">
            <div className="col-span-4">
              {/**Image Gallery Goes here */}
              <Tab.Group as="div" className="flex flex-col-reverse">
                {/* Image selector */}
                <div className="mx-auto mt-6 hidden w-full max-w-2xl sm:block lg:max-w-none">
                  <Tab.List className="grid grid-cols-4 gap-6">
                    {showData ? (
                      uniq?.map((image) => (
                        <Tab
                          key={image}
                          className="relative flex h-24 cursor-pointer items-center justify-center rounded-md bg-white text-sm font-medium uppercase text-gray-900 hover:bg-gray-50 focus:outline-none focus:ring focus:ring-opacity-50 focus:ring-offset-4"
                        >
                          {({ selected }) => (
                            <>
                              <span className="sr-only"> {image} </span>
                              <span className="absolute inset-0 overflow-hidden rounded-md">
                                <img
                                  src={image}
                                  alt=""
                                  className="h-full w-full object-cover object-center"
                                />
                              </span>
                              <span
                                className={classNames(
                                  selected
                                    ? "ring-indigo-500"
                                    : "ring-transparent",
                                  "pointer-events-none absolute inset-0 rounded-md ring-2 ring-offset-2"
                                )}
                                aria-hidden="true"
                              />
                            </>
                          )}
                        </Tab>
                      ))
                    ) : (
                      <></>
                    )}
                  </Tab.List>
                </div>

                <Tab.Panels className="aspect-w-1 aspect-h-1 w-full">
                  {showData ? (
                    uniq?.map((image) => (
                      <Tab.Panel key={image}>
                        <img
                          src={image}
                          className="h-full w-full object-cover object-center sm:rounded-lg"
                        />
                      </Tab.Panel>
                    ))
                  ) : (
                    <></>
                  )}
                </Tab.Panels>
              </Tab.Group>
            </div>
            <div className="col-span-8">
              <div className="h-fit rounded-2 shadow-2xl overflow-hidden bg-white p-8">
                <h1 className="text-3xl font-bold pointer-events-none">
                  {showData ? chosenListing?.property?.name : "Loading..."}
                </h1>
                <div className="relative bottom-6 right-6 inline-grid grid-col-1 grid-rows-1 sm:p-6">
                  <div className=" grid grid-flow-col ">
                    <h2 className="text-sm text-slate-400 italic font-bold">
                      {showData ? chosenListing?.metaverse : "Loading..."}
                    </h2>
                    <div className="grid grid-flow-col ml-2">
                      <EyeIcon className="w-6 text-slate-400" />

                      <p className="cursor-default pointer-events-none text-md text-black font-medium relative left-2">
                        {showData
                          ? chosenListing?.views
                            ? chosenListing?.views
                            : 0
                          : 0}
                      </p>
                      <HeartIcon
                        className="w-6 relative left-6 text-slate-400 hover:text-red-500"
                        onClick={handleUpdateLikes}
                      />
                      <p className="cursor-default pointer-events-none text-md text-black font-medium relative left-8">
                        {showData
                          ? chosenListing?.likes
                            ? chosenListing?.likes
                            : listingLikes
                          : 0}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-3 grid-rows-2 gap-x-4 gap-y-10 grid-flow-row pointer-events-none ">
                  <div className="grid grid-cols-2 grid-rows-2 grid-flow-row">
                    <UserIcon className="h-6 w-6 text-slate-500" />
                    <h3 className="relative right-10 text-sm font-medium">
                      Owner
                    </h3>
                    <p className="ml-16 col-span-2 text-md font-semibold">
                      {showData
                        ? parsedAddress
                          ? parsedAddress
                          : "0x1234567890"
                        : "0x1234567890"}
                    </p>
                  </div>
                  <div className="grid grid-cols-2 grid-rows-2 grid-flow-row">
                    <CurrencyDollarIcon className="h-6 w-6 text-slate-500" />
                    <h3 className="relative right-10 text-sm font-medium">
                      Price
                    </h3>
                    <p className="ml-20 col-span-2 text-md font-semibold">
                      {showData
                        ? chosenListing?.auction?.starting_price
                          ? chosenListing?.auction?.starting_price
                          : chosenListing?.fixed_price?.price
                          ? chosenListing?.fixed_price?.price
                          : chosenListing?.rental?.price
                          ? chosenListing?.rental?.price
                          : "0.0"
                        : "0.0"}
                    </p>
                  </div>
                  <div className="grid grid-cols-2 grid-rows-2 grid-flow-row">
                    <TrashIcon className="h-6 w-6 text-slate-500" />
                    <h3 className="relative right-10 text-sm font-medium">
                      Expiration Date
                    </h3>
                    <p className="ml-20 col-span-2 text-md font-semibold">
                      {showData
                        ? chosenListing?.listing_expiration_date
                          ? moment(
                              chosenListing?.listing_expiration_date
                            ).format("MM/DD/YYYY")
                          : "No Expiration"
                        : "No Expiration"}
                    </p>
                  </div>
                  <div className="grid grid-cols-2 grid-rows-2 grid-flow-row">
                    <BsCardList className="h-6 w-6 text-slate-500" />
                    <h3 className="relative right-10 text-sm font-medium">
                      Token ID
                    </h3>
                    <p className="ml-20 col-span-2 text-md font-semibold">
                      #
                      {showData
                        ? chosenListing?.token_id
                          ? chosenListing?.token_id
                          : "0"
                        : "0"}
                    </p>
                  </div>
                  <div className="grid grid-cols-2 grid-rows-2 grid-flow-row">
                    <IdentificationIcon className="h-6 w-6 text-slate-500" />
                    <h3 className="relative right-10 text-sm font-medium">
                      Contract Address
                    </h3>
                    <p className="ml-20 col-span-2 text-md font-semibold">
                      {showData
                        ? parsedContract
                          ? parsedContract
                          : "0x1234567890"
                        : "0x1234567890"}
                    </p>
                  </div>
                  <div className="grid grid-cols-2 grid-rows-2 grid-flow-row">
                    <MapIcon className="h-6 w-6 text-slate-500" />
                    <h3 className="relative right-10 text-sm font-medium">
                      Address
                    </h3>
                    <p className="ml-20 col-span-2 text-md font-semibold">
                      District X
                    </p>
                  </div>
                </div>
                <div className="mt-10">
                  <PurchaseButton
                    outline="true"
                    purchaseText={purchaseText}
                    onClick={handlePurchaseModal}
                  />
                </div>
              </div>
            </div>
            <div className="col-span-4">
              <div className="rounded-2 shadow-2xl overflow-hidden bg-white p-8">
                <div className="w-full">
                  <Disclosure as="div" className="mb-6">
                    {({ open }) => (
                      <>
                        <Disclosure.Button className="flex w-full justify-between rounded-lg px-4 py-2 text-left text-xl font-semibold  hover:bg-lighter-green ">
                          <span>Description</span>
                          <ChevronUpIcon
                            className={`${
                              open ? "rotate-180 transform" : ""
                            } h-8 w-8`}
                          />
                        </Disclosure.Button>
                        <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
                          {chosenListing?.property?.description
                            ? chosenListing?.property?.description
                            : "No Description"}
                        </Disclosure.Panel>
                      </>
                    )}
                  </Disclosure>
                  <Disclosure as="div" className="mt-2">
                    {({ open }) => (
                      <>
                        <Disclosure.Button className="flex w-full justify-between rounded-lg px-4 py-2 text-left text-xl font-semibold  hover:bg-lighter-green ">
                          <span>About {chosenListing?.metaverse} </span>
                          <ChevronUpIcon
                            className={`${
                              open ? "rotate-180 transform" : ""
                            } h-8 w-8 `}
                          />
                        </Disclosure.Button>
                        <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
                          <p>
                            Suspendisse tristique per mi nullam dignissim
                            facilisis condimentum erat a platea hac at et
                            vestibulum amet sagittis cubilia ullamcorper. Curae
                            Vestibulum Adipiscing eleifend condimentum taciti
                            justo risus vehicula nec a varius est libero lacus.
                            Quisque morbi eros adipiscing
                          </p>
                          <div className="mt-4">
                            <h3 className="font-bold text-sm text-black">
                              Follow on:
                            </h3>
                            <div className="inline-flex mt-2">
                              <div className="rounded-full border border-1 border-solid border-slate-200 w-fit p-1">
                                <FaDiscord className="w-6 h-6 text-logo-green" />
                              </div>
                              <div className="rounded-full border border-1 border-solid border-slate-200 w-fit p-1 ml-2">
                                <FaTwitter className="w-6 h-6 text-logo-green" />
                              </div>
                            </div>
                          </div>
                        </Disclosure.Panel>
                      </>
                    )}
                  </Disclosure>
                </div>
              </div>
            </div>
            <div className="col-span-8 space-y-8">
              <div className="rounded-2 shadow-2xl overflow-hidden p-8 bg-white pointer-events-none">
                <h2 className="text-2xl text-logo-green font-bold">
                  Top Offer
                </h2>
                <div className="grid grid-cols-2 divide-x-2 mt-4 relative right-24">
                  <div className="grid grid-cols-2 grid-rows-2 grid-flow-row">
                    <CurrencyDollarIcon className="h-6 w-6 text-slate-500 ml-24" />
                    <h3 className="relative right-10 text-md font-medium">
                      Top Offer Price:
                    </h3>
                    <p className="ml-36 col-span-2 text-lg font-semibold">24</p>
                  </div>
                  <div className="grid grid-cols-2 grid-rows-2 grid-flow-row">
                    <IdentificationIcon className="h-6 w-6 text-slate-500 ml-6" />
                    <h3 className="relative right-24 text-md font-medium">
                      From
                    </h3>
                    <p className="ml-20 col-span-2 text-lg font-semibold">
                      0x123456789
                    </p>
                  </div>
                </div>
              </div>
              <div className="rounded-2 shadow-2xl overflow-hidden p-8 bg-white">
                <h2 className="text-2xl text-logo-green-active font-bold">
                  Offers
                </h2>
                <div className="sm:px-6">
                  <div className=" mt-8 overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:-mx-6  md:rounded-lg">
                    <table className="min-w-full divide-y divide-gray-300 pointer-events-none">
                      <thead className="bg-logo-green">
                        <tr>
                          <th
                            scope="col"
                            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-white sm:pl-6"
                          >
                            From
                          </th>
                          <th
                            scope="col"
                            className="hidden px-3 py-3.5 text-left text-sm font-semibold text-white lg:table-cell"
                          >
                            Price
                          </th>
                          <th
                            scope="col"
                            className="hidden px-3 py-3.5 text-left text-sm font-semibold text-white sm:table-cell"
                          >
                            USD Price
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-white"
                          >
                            Expiration
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {offers.map((offer) => (
                          <tr key={offer.id}>
                            <td className="w-full max-w-0 py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:w-auto sm:max-w-none sm:pl-6">
                              {offer.from}
                              <dl className="font-normal lg:hidden">
                                <dt className="sr-only">Price</dt>
                                <dd className="mt-1 truncate text-gray-700">
                                  {offer.Price}
                                </dd>
                                <dt className="sr-only sm:hidden">USD Price</dt>
                                <dd className="mt-1 truncate text-gray-500 sm:hidden">
                                  {offer.UsdPrice}
                                </dd>
                              </dl>
                            </td>
                            <td className="hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">
                              {offer.Price}
                            </td>
                            <td className="hidden px-3 py-4 text-sm text-gray-500 sm:table-cell">
                              {offer.UsdPrice}
                            </td>
                            <td className="px-3 py-4 text-sm text-gray-500">
                              {offer.Expiration}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="rounded-2 shadow-2xl overflow-hidden p-8 bg-white">
                <h2 className="text-2xl font-bold">Acre Map</h2>
              </div>
              <div className="rounded-2 shadow-2xl overflow-hidden p-8 bg-white">
                <h2 className="text-2xl font-bold">Price History Graph</h2>
              </div>
              <div className="rounded-2 shadow-2xl overflow-hidden p-8 bg-white">
                <h2 className="text-2xl font-bold">Property Stats</h2>
              </div>
              <div className="rounded-2 shadow-2xl overflow-hidden p-8 bg-white">
                <h2 className="text-2xl font-bold">Metaverse Stats</h2>
              </div>
            </div>
            <div className="col-span-12">
              <div className="rounded-2 shadow-2xl overflow-hidden p-8 bg-white">
                <h2 className="text-2xl font-bold">Item Activity</h2>
                <div className="sm:px-6">
                  <div className=" mt-8 overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:-mx-6  md:rounded-lg">
                    <table className="min-w-full divide-y divide-gray-300 pointer-events-none">
                      <thead className="bg-logo-green">
                        <tr>
                          <th
                            scope="col"
                            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-white sm:pl-6"
                          >
                            From
                          </th>
                          <th
                            scope="col"
                            className="hidden px-3 py-3.5 text-left text-sm font-semibold text-white lg:table-cell"
                          >
                            Price
                          </th>
                          <th
                            scope="col"
                            className="hidden px-3 py-3.5 text-left text-sm font-semibold text-white sm:table-cell"
                          >
                            USD Price
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-white"
                          >
                            Expiration
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {offers.map((offer) => (
                          <tr key={offer.id}>
                            <td className="w-full max-w-0 py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:w-auto sm:max-w-none sm:pl-6">
                              {offer.from}
                              <dl className="font-normal lg:hidden">
                                <dt className="sr-only">Price</dt>
                                <dd className="mt-1 truncate text-gray-700">
                                  {offer.Price}
                                </dd>
                                <dt className="sr-only sm:hidden">USD Price</dt>
                                <dd className="mt-1 truncate text-gray-500 sm:hidden">
                                  {offer.UsdPrice}
                                </dd>
                              </dl>
                            </td>
                            <td className="hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">
                              {offer.Price}
                            </td>
                            <td className="hidden px-3 py-4 text-sm text-gray-500 sm:table-cell">
                              {offer.UsdPrice}
                            </td>
                            <td className="px-3 py-4 text-sm text-gray-500">
                              {offer.Expiration}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TopPropertiesCarousel />
        </main>
        <img
          className="absolute -z-10 bottom-0 left-0 w-full"
          src={homeCabooseBgImg}
          alt=""
        />
      </div>
      {showModal ? (
        <AuthenticationModal
          openModal={true}
          children={() => {
            return (
              <RoundedButton outline={true} onClick={() => connect()}>
                {connecting ? "Connecting..." : "Connect Wallet"}
              </RoundedButton>
            );
          }}
        />
      ) : (
        <></>
      )}
      {purchaseModal}
      <Footer />
    </>
  );
}

export default PropertyDetailPage;
